<template>
  <div :style="!isSection?'height: 0px':''">
    <a name="form" id="form" class="form-anchor">&nbsp;</a>
    <!-- popups -->
    <div :class="{'popups':true,'section':isSection}">
      <div class="popups__overlay"></div>
      <!-- popup -->
      <div class="popup" id="checkout" :style="`display: ${showPopup}`">
        <!-- section -->
        <div class="checkout">
          <div class="container popup__container">
            <div v-if="!isSection" class="popup__close js-popup-close" @click="$emit('close')"></div>
            <form action="./ajax.php">
              <h2 class="checkout__title title">Оформление заказа</h2>
              <div class="checkout__box">
                <div class="checkout__col checkout__col-cover">
                  <div class="checkout__cover">
                    <img src="../assets/images/order.jpg" alt="" />
                  </div>
                </div>
                <div class="checkout__colgroup">
                  <div class="checkout__row">
                    <div class="checkout__label">Помещение</div>
                    <div class="checkout__vals">
                      <div class="form-radio">
                        <input type="radio" class="form-radio__inp" name="room_type" value="apartment" :id="`apartment-${fIndex}`" checked />
                        <label :for="`apartment-${fIndex}`" class="form-radio__label">Квартира</label>
                      </div>
                      <div class="form-radio">
                        <input type="radio" class="form-radio__inp" name="room_type" value="house" :id="`house-${fIndex}`" />
                        <label :for="`house-${fIndex}`" class="form-radio__label">Дом</label>
                      </div>
                      <div class="form-radio">
                        <input type="radio" class="form-radio__inp" name="room_type" value="townhouse" :id="`townhouse-${fIndex}`" />
                        <label :for="`townhouse-${fIndex}`" class="form-radio__label">Таунхаус</label>
                      </div>
                    </div>
                  </div>
                  <div class="checkout__row">
                    <div class="checkout__label">Площадь дома</div>
                    <div class="checkout__vals">
                      <div class="form-radio">
                        <input type="radio" class="form-radio__inp" name="house_area" value="s1" :id="`s1-${fIndex}`" checked />
                        <label :for="`s1-${fIndex}`" class="form-radio__label">до 50 м<sup>2</sup></label>
                      </div>
                      <div class="form-radio">
                        <input type="radio" class="form-radio__inp" name="house_area" value="s2" :id="`s2-${fIndex}`" />
                        <label :for="`s2-${fIndex}`" class="form-radio__label">50—100 м<sup>2</sup></label>
                      </div>
                      <div class="form-radio">
                        <input type="radio" class="form-radio__inp" name="house_area" value="s3" :id="`s3-${fIndex}`" />
                        <label :for="`s3-${fIndex}`" class="form-radio__label">100—200 м<sup>2</sup></label>
                      </div>
                      <div class="form-radio">
                        <input type="radio" class="form-radio__inp" name="house_area" value="s4" :id="`s4-${fIndex}`" />
                        <label :for="`s4-${fIndex}`" class="form-radio__label">более 200 м<sup>2</sup></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="checkout__box checkout__box_content">
                <div class="checkout__col">
                  <div class="checkout__ch">
                    <div class="form-ch">
                      <input type="checkbox" class="form-ch__inp" name="lighting" :id="`lighting-${fIndex}`" checked />
                      <label :for="`lighting-${fIndex}`" class="form-ch__label">Свет и управление
                        приборами</label>
                    </div>
                  </div>
                  <div class="checkout__list-box">
                    <!-- <div class="checkout__list-toggle" @click="$set(toggleList, 0, !toggleList[0])">{{ !toggleList[0]?'Подробно':'Скрыть'}}</div> -->
                    <ul :class="{'list':true,'active':toggleList[0]}">
                      <li class="list__item">Управление светом со смартфона через приложение
                        Home
                      </li>
                      <li class="list__item">Управление светом с помощью Siri</li>
                      <li class="list__item">Диммирование источников освещения</li>
                      <li class="list__item">Управление источниками цветного освещения</li>
                      <li class="list__item">Объединение источников и назначение групп света</li>
                      <li class="list__item">Создание сценариев в зависимости от движения в
                        помещении
                      </li>
                      <li class="list__item">Создание сценариев в зависимости от освещенности
                        помещения
                      </li>
                    </ul>
                  </div>
                  <div class="checkout__price"></div>
                </div>
                <div class="checkout__col">
                  <div class="checkout__ch">
                    <div class="form-ch">
                      <input type="checkbox" class="form-ch__inp" name="security" :id="`security-${fIndex}`" />
                      <label :for="`security-${fIndex}`" class="form-ch__label">Безопасность</label>
                    </div>
                  </div>
                  <div class="checkout__list-box">
                    <!-- <div class="checkout__list-toggle" @click="$set(toggleList, 1, !toggleList[1])">{{ !toggleList[1]?'Подробно':'Скрыть'}}</div> -->
                    <ul :class="{'list':true,'active':toggleList[1]}">
                      <li class="list__item">Управление системами безопасности со смартфона через
                        приложение Home
                      </li>
                      <li class="list__item">Получение тревожных сообщений на смартфон при
                        срабатывании датчиков
                      </li>
                      <li class="list__item">Акустическое оповещение системой при срабатывании
                        датчиков
                      </li>
                      <li class="list__item">Анализ данных с датчиков движения, открытия дверей,
                        дыма,
                        протечек
                      </li>
                      <li class="list__item">Принудительное перекрытие источников водоснабжения
                      </li>
                      <li class="list__item">Создание сценариев на постановку снятие помещения с
                        охраны
                      </li>
                      <li class="list__item">Получение данный с камеры наблюдения и других
                        датчиков
                      </li>
                    </ul>
                  </div>
                  <div class="checkout__price"></div>
                </div>
                <div class="checkout__col">
                  <div class="checkout__ch">
                    <div class="form-ch">
                      <input type="checkbox" class="form-ch__inp" name="comfort" :id="`comfort-${fIndex}`" />
                      <label :for="`comfort-${fIndex}`" class="form-ch__label">Комфорт</label>
                    </div>
                  </div>
                  <div class="checkout__list-box">
                    <!-- <div class="checkout__list-toggle" @click="$set(toggleList, 2, !toggleList[2])">{{ !toggleList[2]?'Подробно':'Скрыть'}}</div> -->
                    <ul :class="{'list':true,'active':toggleList[2]}">
                      <li class="list__item">Управление климатом со смартфона через приложение
                        Home
                      </li>
                      <li class="list__item">Управление климатом с помощью Siri</li>
                      <li class="list__item">Управление климатической техникой</li>
                      <li class="list__item">Управление отоплением и теплыми полами</li>
                      <li class="list__item">Создание сценариев в зависимости от влажности в
                        помещении
                      </li>
                      <li class="list__item">Создание сценариев в зависимости от температуры
                        помещения
                      </li>
                    </ul>
                  </div>
                  <div class="checkout__price"></div>
                </div>
              </div>
            </form>
          </div>
          <div class="request">
            <div class="container">
              <div class="request__row request__row-short">
                <div class="request__col request__col-short">
                  <div class="request__txt"></div>
                  <div class="request__price"><span class="request__price-value"></span></div>
                </div>
                <div class="request__col request__col_content">
                  <div class="request__txt request__txt_descript">Отправьте ваш запрос, мы рассчитаем точную стоимость после обсуждения вашего проекта с&nbsp;нашим специалистом.
                  </div>
                </div>
              </div>
              <!-- <form name="sampleForm" method="POST" action="//onlyoffice.razumvdom.ru/products/crm/httphandlers/webtoleadfromhandler.ashx" accept-charset="UTF-8">
                <meta content="text/html;charset=UTF-8" http-equiv="content-type">
                <style type="text/css">#sampleFormPanel { padding: 10px; } #sampleFormPanel dt { float: left; text-align: right; width: 40%; } #sampleFormPanel dd:not(:first-child) { margin-bottom: 5px; margin-left: 40%; padding-left: 10px; } #sampleFormPanel input[type=text] { border: solid 1px #C7C7C7; } #sampleFormPanel input[type=checkbox] { margin-left: 0; } #sampleFormPanel .requiredField:after { color: #c00; content: " *"; font-size: 12px; vertical-align: text-top; }</style>
                <dl id="sampleFormPanel">
                  <dt><input type="hidden" name="is_company" value="false"></dt><dd></dd><dt><div class="requiredField">Имя:</div></dt>
                  <dd><input name="firstName" type="text"></dd><dt> Фамилия: </dt>
                  <dd><input name="lastName" type="text"></dd><dt> Телефон: </dt><dd><input name="contactInfo_Phone_1" type="text"></dd><dt> Электронная почта: </dt><dd><input name="contactInfo_Email_1" type="text"></dd><dt></dt>
                  <dd><input name="" value="Отправить данные" type="submit" onclick="javascript: var isValid = true, form = document.getElementById('sampleFormPanel'), childs = form.getElementsByTagName('input'), isCompany = null, firstName = '', lastName = '', companyName = '', fieldName = ''; for (var i = 0, n = childs.length; i < n; i++) { fieldName = childs[i].getAttribute('name'); switch (fieldName) { case 'is_company': isCompany = childs[i].value.trim(); break; case 'firstName': firstName = childs[i].value.trim(); break; case 'lastName': lastName = childs[i].value.trim(); break; case 'companyName': companyName = childs[i].value.trim(); break; } } if (isCompany == 'false') { if (firstName == ''){ if(typeof (toastr) === 'object' &amp;&amp; typeof (toastr.error) === 'function') toastr.error('Введите имя'); else alert('Введите имя'); isValid = false; } } else if (isCompany == 'true') { if(companyName == '') { if(typeof (toastr) === 'object' &amp;&amp; typeof (toastr.error) === 'function') toastr.error('Введите название компании'); else alert('Введите название компании'); isValid = false; } } else { isValid = false; } return isValid;"></dd></dl>
                  <input type="hidden" name="return_url" value="/success">
                  <input type="hidden" name="web_form_key" value="0bf14cd2-7762-4ef1-b8ca-9d022bf3aaf6">
                  <input type="hidden" name="notify_list" value="4f80a17d-5fa9-440e-b9ce-543e8b2bbbb0">
                  <input type="hidden" name="managers_list" value="4f80a17d-5fa9-440e-b9ce-543e8b2bbbb0">
                  <input type="hidden" name="share_type" value="2">
                </form> -->
              <form method="POST" action="//api.razumvdom.ru:5443/order/" accept-charset="UTF-8" id="request-form-popup" novalidate="novalidate">
                <div class="request__row request__row_form">
                  <div class="request__col request__col-inputs">
                    <div class="request__col-inputs-inputs">
                      <div class="request__col request__col-inputs-item">
                        <input type="hidden" name="is_company" value="false">
                        <input type="text" class="form-area" name="firstName" required="" placeholder="Имя" aria-required="true">
                        <input type="hidden" name="lastName" value="">
                      </div>
                      <div class="request__col request__col-inputs-item">
                        <input type="text" class="form-area" name="contactInfo_Phone_1" required="" placeholder="Телефон" aria-required="true">
                      </div>
                      <div class="request__col request__col-inputs-item">
                        <input type="text" class="form-area" name="contactInfo_Email_1" required="" placeholder="E-mail" aria-required="true">
                      </div>
                    </div>
                    <div class="request__col-inputs-comment">
                      <textarea name="about" id="" class="form-area form-area_comment" placeholder="Комментарий (не обязательно)" cols="30" rows="1"></textarea>
                      <input type="hidden" name="return_url" value="http://razumvdom.ru/thanks">
                      <input type="hidden" name="web_form_key" value="0bf14cd2-7762-4ef1-b8ca-9d022bf3aaf6">
                      <input type="hidden" name="notify_list" value="e4c8d47f-cc97-11ea-bf8e-00155d58ec03">
                      <input type="hidden" name="managers_list" value="e4c8d47f-cc97-11ea-bf8e-00155d58ec03">
                      <input type="hidden" name="share_type" value="2">
                    </div>
                  </div>
                  <div class="request__col request__col-btn">
                    <input type="submit" class="btn btn_full btn_animate" onclick="form.submit()">
                    <!-- <div class="files-add">
                                            <label class="files-add_label">
                                                <input class="inputfile valid" type="file" name="photos[]" multiple="" accept="image/*,image/jpeg">
                                                <span class="attach-file_label">Приложить файл</span></label>
                                            <div class="file-add_container" id="box-container"></div>
                                        </div> -->
                  </div>
                </div>
              </form>
              <!-- <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeB9jmj6LETMG21R5sl_BgPfAQToA0fpsMOf6aA_Rs_tsg05A/viewform?embedded=true" width="640" height="677" frameborder="0" marginheight="0" marginwidth="0">Загрузка…</iframe> -->
              <div class="request-agreement">
                Нажимая на кнопку «Отправить заявку», вы соглашаетесь с&nbsp;<a href="/oferta/" target="_blank" rel="nofollow">публичной офертой</a> и <a href="/politika/" target="_blank" rel="nofollow">политикой конфиденциальности</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- popup -->
      <div class="popup" id="done">
        <div class="container popup-content-box">
          <div class="popup__close js-popup-close"></div>
          <div class="popup-content">
            <div id="popup-title" class="popup-content__title">Спасибо за заказ!</div>
            <div id="popup-ok" class="popup-content__descript">Ваша заявка принята. Совсем скоро<br /> с вами
              свяжется наш
              менеджер.
            </div>
            <div id="popup-error" style="display: none;" class="popup-content__descript">
            </div>
            <div class="popup-content__row">
              <a href="#" class="btn js-popup-close">Закрыть</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  props: ['isSection'],
  data() {
    return {
      overlay: null,
      st: 0,
      isOpen: false,
      state: {
        size: 's1',
        type: 'apartment',
        light: true,
        security: false,
        comfort: false,
      },
      data: {},
      toggleList: [0, 0, 0],
      fIndex: this.isSection ? 3 : 2,
    }
  },
  computed: {
    showPopup() {
      return this.isSection || this.$store.state.showPopup ? 'block' : 'none';
    },
  },
  watch: {
    showPopup(val) {
      if (val) this.open();
    }
  },
  mounted() {

    var _this = this;

    this.overlay = $('.popups__overlay');

    $('#order').on('click', function() {
      // $('.mobile-menu__close').click();
      // $('#order-btn').click();
      _this.open($('#checkout'));
      $('#checkout').css('display', 'block!important');
    });

    $('[data-popup]').on('click', function(e) {
      e.preventDefault();

      var id = $(this).data('popup');
      var $popup = $('#' + id);

      if ($popup.length) {
        _this.open($popup);
      }
    });
    $('.js-popup-close').on('click', function(e) {
      e.preventDefault();

      var $popup = $(this).closest('.popup');

      if ($popup.length) {
        _this.close($popup);
      }
    });

    window.addEventListener("orientationchange", function() {
      if (_this.isOpen && _this.isIos()) {
        $('body').css({
          position: '',
          marginTop: '',
          width: ''
        });

        setTimeout(function() {
          $('body').css({
            position: 'fixed',
            marginTop: -_this.st,
            width: '100%'
          });
        }, 0);

      }
    });

    //calc - + - + - + - + - + - + - + - + -

    // if($('input[name=phone]').val()) { //<<<--- phone validation
    //     $('input[name=phone]').mask('+7 (999) 999-99-99');
    // }
    /**
     * Коэффициенты,
     * на основе которых вычисляется цена
     */


    this.data = { //<<<--- test data
      "type": {
        "apartment": 1,
        "house": 1.1,
        "townhouse": 1.07
      },
      "size": {
        "s1": 1,
        "s2": 1.3,
        "s3": 1.7,
        "s4": 2.1
      },
      "light": 69990,
      "security": 79990,
      "comfort": 89990,
      "one_option": 0,
      "two_options": -20000,
      "three_options": -40000
    };

    // $.ajax({
    //     type: 'GET',
    //     url: './ajax.php?act=get-tariff',
    //     dataType: 'json',
    //     success: function (json) {
    //         data = json;
    //     },
    //     async: false
    // });
    /**
     * Текущее состояние калькулятора
     */

    $('.checkout input').on('change', this.changeAreaHadler);
    this.updateCalculation();
  },
  methods: {
    open: function(popup) {
      var $popups = $('.popup');
      var _this = this;
      // var popup = $('#checkout');

      // Закрываем открытые попапы 
      $popups.each(function(i, el) {
        if ($(el).is(':visible')) {
          _this.close($(el));
        }
      });

      $('body').addClass('no-scroll');
      this.overlay.addClass('popups__overlay_show');
      popup.addClass('popup_translate')
        .show(0)
        .removeClass('popup_translate');

      // fix для ios
      if (_this.isIos()) {
        _this.st = window.pageYOffset;

        $('body').css({
          position: 'fixed',
          marginTop: -_this.st,
          width: '100%'
        });
      }

      _this.isOpen = true;
      this.displayCheckout = 'block';
    },
    close: function(popup) {
      var _this = this;
      popup.addClass('popup_translate');
      $('body').removeClass('no-scroll');
      this.overlay.removeClass('popups__overlay_show');

      setTimeout(function() {
        popup.hide(0);

        if (_this.isIos()) {
          $('body').removeClass('no-scroll')
            .css({
              position: '',
              marginTop: '',
              width: ''
            });

          $('html, body').scrollTop(_this.st);
          _this.st = 0;
        }
      }, 300);

      _this.isOpen = false;
    },
    isIos: function() {
      return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    },
    calc: function() {
      /**
       * Вычисление цены на основе текущего состояния
       */
      var result = 0;
      var cnt = 0;
      var sale = 0;
      var price = 0;

      if (this.state.light) {
        result += this.roundUp(this.data.light * this.data.size[this.state.size]);
        cnt++;
      }
      if (this.state.security) {
        result += this.roundUp(this.data.security * this.data.size[this.state.size]);
        cnt++;
      }
      if (this.state.comfort) {
        result += this.roundUp(this.data.comfort * this.data.size[this.state.size]);
        cnt++;
      }
      if (cnt === 1) {
        sale = this.data.one_option;
      } else if (cnt === 2) {
        sale = this.data.two_options;
      } else if (cnt === 3) {
        sale = this.data.three_options;
      }

      price = this.roundUp((result + sale) * this.data.type[this.state.type]);
      this.$store.commit('setDataProp', { price: this.formatPrice(price) });
      return this.formatPrice(price);
    },
    formatPrice: function(val) {
      /**
       * Форматирование цены
       * @param {number} val
       * @return {string} тысячи отделены пробелом
       */
      if (!val) {
        return 0;
      }
      return String(val).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
    updateCalculation: function() {
      /**
       * Синхронизация калькуляторов и
       * вывод значения
       */
      var price = this.calc();

      $('.checkout').each(function() {

        var $self = $(this);
        var $types = $self.find("[name='room_type']");
        var $sizes = $self.find("[name='house_area']");

        $types.each(function() {
          var $self = $(this);

          if ($self.val() === this.state.type) {
            $self.prop('checked', true);
          }
        });
        $sizes.each(function() {
          var $self = $(this);
          if ($self.val() === this.state.size) {
            $self.prop('checked', true);
          }
        });

        $self.find("[name='lighting']").prop('checked', this.state.light);
        $self.find("[name='security']").prop('checked', this.state.security);
        $self.find("[name='comfort']").prop('checked', this.state.comfort);

        $(".request__price-value").text(price)

      }.bind(this));
    },
    changeAreaHadler: function(e) {
      /**
       * Обработчик изменений элемента формы калькулятора
       */

      var $self = $(e.target);
      var name = $self.attr('name');
      var val = $self.val();

      switch (name) {
        case 'room_type':
          {
            this.setState('type', val);
            break;
          }
        case 'house_area':
          {
            this.setState('size', val);
            break;
          }
        case 'lighting':
          {
            this.setState('light', $self.is(':checked'));
            break;
          }
        case 'security':
          {
            this.setState('security', $self.is(':checked'));
            break;
          }
        case 'comfort':
          {
            this.setState('comfort', $self.is(':checked'));
            break;
          }
        default:
          {
            return false;
          }
      }
    },
    roundUp: function(number) {
      return Math.ceil(number / 10) * 10;
    },
    setState: function(key, value) {
      if (this.state.hasOwnProperty(key)) {
        this.state[key] = value;
      }
      this.updateCalculation();
    },
  },
}
</script>
<style>
.popups__overlay {
  width: 100%;
  height: 100%;
  background: #000;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  display: none;
  opacity: 0;
  transition: opacity .25s ease .25s, z-index 0s ease .5s;
}

.popups__overlay_show {
  z-index: 7;
  opacity: .4;
  display: block;
  transition: opacity .25s ease 0s, z-index 0s ease 0s;
}

.popup {
  display: none; 
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
  z-index: 999999;
  transition: .5s ease 0s;
  -webkit-overflow-scrolling: touch;
}

.popups.section .popup {
  display: block;
  position: static;
}

.popups.section .popups__overlay {
  display: none;
}

#done {
  display: none;
}

.popup__container {
  padding: 50px 0 0;
  position: static !important;
}

.popup__close {
  width: 60px;
  height: 60px;
  position: absolute;
  right: 40px;
  top: 40px;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  transition: .25s ease;
  background: #f2f2f2 url(../assets/images/close.png) center center no-repeat;
}

.popup__close::before {
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.popup__close::after {
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.popup_translate {
  -ms-transform: translateY(-150%);
  transform: translateY(-150%);
  overflow: hidden;
}

.popup-content-box {
  height: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  position: static !important;
}

.popup-content__title {
  font: 32px/24px "Graphik-Medium-Cy", sans-serif;
}

.popup-content__descript {
  font-size: 14px;
  line-height: 21px;
  margin-top: 30px;
}

.popup-content__row {
  margin-top: 35px;
}

.popup-content__row .btn {
  width: 160px;
}

.form-anchor {
  height: 60px;
  margin-top: 40px;
}

/* Adaptive */
@media screen and (max-width: 767px) {
  .popup__container {
    padding: 0;
  }

  .checkout__col,
  .request__col-short,
  .request__col_content,
  .request__col-btn {
    width: auto !important;
  }

  .checkout__col-cover {
    display: none;
  }

  .checkout__title {
    font-size: 24px !important;
    margin: 0 15px !important;
  }

  .checkout__box {
    margin: 10px 15px 30px;
    position: relative;
  }

  .checkout__colgroup {
    width: 100%;
  }

  .checkout__row {
    flex-direction: column;
    margin-top: 20px;
  }

  .checkout__row:nth-of-type(2) {
    position: absolute;
    top: 0;
    left: 220px;
  }

  .checkout__vals {
    display: block !important;
  }

  .checkout__box_content {
    flex-direction: column;
  }

  .checkout__box_content .checkout__col {
    margin-top: 20px;
  }

  .checkout__list-box .list {
    transition: opacity 1s ease-out;
    opacity: 0;
    height: 0;
    overflow: hidden;
  }

  .checkout__list-box .list.active {
    opacity: 1;
    height: auto;
  }

  .checkout__list-toggle {
    font-size: 12px;
    color: #78b301;
    margin: -5px 0 5px;
  }

  .request {
    margin-top: 20px !important;
    padding: 25px 15px !important;
  }

  .request__row {
    flex-direction: column;
  }

  .request__col_content {
    margin-top: 10px;
  }

  .request__txt_descript {
    font-size: 12px;
    line-height: normal;
    color: #999;
  }

  .request__col-inputs-inputs {
    flex-direction: column;
  }

  .request__col-inputs-item,
  .form-area_comment,
  .btn_full {
    margin-bottom: 5px;
    width: 300px !important;
    padding: 0 !important;
  }

  .form-area_comment {
    padding: 12px !important;
    margin-bottom: 20px;
  }
}
</style>